const PRELOADED_ACTIONS = {
  ARTICLES_LOADED: 'ARTICLES_LOADED',
  AUTHORISED_ROLES_LOADED: 'AUTHORISED_ROLES_LOADED',
  TEMPLATES_LOADED: 'TEMPLATES_LOADED',
  CATEGORIES_LOADED: 'CATEGORIES_LOADED',
  AUTOMATIONS_LOADED: 'AUTOMATIONS_LOADED',
  STATS_LOADED: 'STATS_LOADED',
  USER_STATS_LOADED: 'USER_STATS_LOADED',
  MENU_ITEMS_LOADED: 'MENU_ITEMS_LOADED',
  SETTINGS_LOADED: 'SETTINGS_LOADED',
  APPS_LOADED: 'APPS_LOADED',
  PROMPTS_LOADED: 'PROMPTS_LOADED',
  ACTIONS_LOADED: 'ACTIONS_LOADED',
  DATASOURCES_LOADED: 'DATASOURCES_LOADED',
  THEMES_LOADED: 'THEMES_LOADED',
  PAGES_LOADED: 'PAGES_LOADED',
  PAGE_TEMPLATES_LOADED: 'PAGE_TEMPLATES_LOADED'
};

const articlesLoadedAction = articles => {
  return {
    type: PRELOADED_ACTIONS.ARTICLES_LOADED,
    payload: articles
  };
};

const pagesLoadedAction = pages => {
  return {
    type: PRELOADED_ACTIONS.PAGES_LOADED,
    payload: pages
  };
};

const pageTemplatesLoadedAction = templates => {
  return {
    type: PRELOADED_ACTIONS.PAGE_TEMPLATES_LOADED,
    payload: templates
  };
};

const datasourcesLoadedAction = ({ appId, datasources }) => {
  return {
    type: PRELOADED_ACTIONS.DATASOURCES_LOADED,
    payload: { appId, datasources }
  };
};

const themesLoadedAction = ({ appId, themes }) => {
  return {
    type: PRELOADED_ACTIONS.THEMES_LOADED,
    payload: { appId, themes }
  };
};

const actionsLoadedAction = ({ appId, actions }) => {
  return {
    type: PRELOADED_ACTIONS.ACTIONS_LOADED,
    payload: { appId, actions }
  };
};

const promptsLoadedAction = prompts => {
  return {
    type: PRELOADED_ACTIONS.PROMPTS_LOADED,
    payload: prompts
  };
};

const menuItemsLoadedAction = menuItems => {
  return {
    type: PRELOADED_ACTIONS.MENU_ITEMS_LOADED,
    payload: menuItems
  };
};

const appsLoadedAction = apps => {
  return {
    type: PRELOADED_ACTIONS.APPS_LOADED,
    payload: apps
  };
};

const authorisedRolesLoadedAction = roles => {
  return {
    type: PRELOADED_ACTIONS.AUTHORISED_ROLES_LOADED,
    payload: roles
  };
};

const settingsLoadedAction = settings => {
  return {
    type: PRELOADED_ACTIONS.SETTINGS_LOADED,
    payload: settings
  };
};

const statsLoadedAction = stats => {
  return {
    type: PRELOADED_ACTIONS.STATS_LOADED,
    payload: stats
  };
};
const userStatsLoadedAction = stats => {
  return {
    type: PRELOADED_ACTIONS.USER_STATS_LOADED,
    payload: stats
  };
};

const templatesLoadedAction = articles => {
  return {
    type: PRELOADED_ACTIONS.TEMPLATES_LOADED,
    payload: articles
  };
};

const automationsLoadedAction = automations => {
  return {
    type: PRELOADED_ACTIONS.AUTOMATIONS_LOADED,
    payload: automations
  };
};

const categoriesLoadedAction = categories => {
  return {
    type: PRELOADED_ACTIONS.CATEGORIES_LOADED,
    payload: categories
  };
};

export {
  PRELOADED_ACTIONS,
  categoriesLoadedAction,
  articlesLoadedAction,
  templatesLoadedAction,
  automationsLoadedAction,
  statsLoadedAction,
  userStatsLoadedAction,
  authorisedRolesLoadedAction,
  menuItemsLoadedAction,
  settingsLoadedAction,
  appsLoadedAction,
  promptsLoadedAction,
  actionsLoadedAction,
  datasourcesLoadedAction,
  themesLoadedAction,
  pagesLoadedAction,
  pageTemplatesLoadedAction
};
